<template lang="html">
  <div class="examplex">
    <vs-popup title="Selecciona un restaurante" class="popup-w-900 background-disabled"
      :active.sync="popupCurrentRestaurant" :button-close-hidden="buttonClose">
      <div class="vx-row justify-center">
        <div class="vx-col sm:w-full md:w-full lg:w-10/12 mb-6">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mb-6" v-for="(item, index) in restaurants"
              @click="setRestaurant(item.id)" :key="index">
              <vs-card actionable class="cardx">
                <div slot="media">
                  <img :src="item.images[0].path" v-if="item.images[0]" />
                  <img :src="imageDefault" v-else />
                </div>
                <div>
                  <h4 class="mb-3">{{ item.name }}</h4>
                </div>
              </vs-card>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  props: {
    restaurants: {
      type: Array,
      required: true,
    },
  },
  methods: {
    setRestaurant(value) {
      this.$store.commit('setCurrentRestaurant', value);
      location.reload();
    },
  },
  data() {
    return {
      popupCurrentRestaurant: true,
      imageDefault: process.env.VUE_APP_IMAGE_PLACEHOLDER,
      buttonClose: true,
    };
  },
};
</script>
